import { render, staticRenderFns } from "./LChat.vue?vue&type=template&id=bd0f9712&scoped=true"
import script from "./LChat.vue?vue&type=script&lang=ts"
export * from "./LChat.vue?vue&type=script&lang=ts"
import style0 from "./LChat.vue?vue&type=style&index=0&id=bd0f9712&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0f9712",
  null
  
)

export default component.exports